import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, ViewChild,OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { AlertController, LoadingController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import { GlobalPage } from '../global/global.page';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

@Component({
  selector: 'app-signature-verification',
  templateUrl: './signature-verification.page.html',
  styleUrls: ['./signature-verification.page.scss'],
})
export class SignatureVerificationPage implements AfterViewInit {
  @ViewChild('signatureCanvas', { static: false }) signatureCanvas: ElementRef<HTMLCanvasElement>;
  signatureImg : string;
  
  details: any;
  sign: any;
  signimg: any;
  signimgpath: any;
  signn: any = [];
  deviceWidth:any;
  width: number;
  
  private ctx: CanvasRenderingContext2D;
  private isDrawing = false;
  private lastX = 0;
  private lastY = 0;
  
  drawstart: boolean;
  IsMemberSigned : boolean;
  IsMemberUnableToSign : boolean;
  IsMemberRefusesToSign : boolean;
  MemberRefuseSignReason : string;
  IsFacilitySigned : boolean;
   IsFacilityRefusesToSign : boolean;
   FaciltyRefuseSignReason : string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController,
    public global: GlobalPage, public loadingCtrl: LoadingController, public http: HttpClient,
    public storage1:Storage,public plt:Platform,public router:Router,public screenoriendation:ScreenOrientation,public toastCtrl:ToastController) { 
    if(window.innerWidth<650){
      this.width=window.innerWidth - 33;
      this.deviceWidth= (window.innerWidth-30)+'px';
    }
    else{
      this.width=600;
      this.deviceWidth= 603+'px';
    }
    
    this.screenoriendation.onChange().subscribe(
      () => {
        setTimeout(()=>{
          this.getDeviceWidth();
        },200)
      }
   );
   if (this.router.getCurrentNavigation().extras.state) {
    let record = this.router.getCurrentNavigation().extras.state.details;
    this.details = record;
  }
   }
   
   ngAfterViewInit() {
    console.log("ngafterviewinit")
    setTimeout(() => {
      console.log('Canvas reference:', this.signatureCanvas);
      if (this.signatureCanvas) {
        try {
          this.initializeCanvas();
          console.log('Canvas initialized successfully');
        } catch (error) {
          console.error('Error initializing Canvas:', error);
        }
      } else {
        console.error('Canvas not found in ViewChild');
      }
    }, 500);
    this.ionViewDidLoad();
  }

  private initializeCanvas() {
    const canvas = this.signatureCanvas.nativeElement;
    this.ctx = canvas.getContext('2d');
    
    // Set canvas size
    canvas.width = this.width;
    canvas.height = 200;
    
    // Set drawing styles
    this.ctx.strokeStyle = '#000000';
    this.ctx.lineWidth = 2;
    this.ctx.lineCap = 'round';
    this.ctx.lineJoin = 'round';
    
    // Add event listeners
    this.addCanvasEventListeners();
  }

  private addCanvasEventListeners() {
    const canvas = this.signatureCanvas.nativeElement;
    
    // Mouse events
    canvas.addEventListener('mousedown', this.startDrawing.bind(this));
    canvas.addEventListener('mousemove', this.draw.bind(this));
    canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.addEventListener('mouseout', this.stopDrawing.bind(this));
    
    // Touch events
    canvas.addEventListener('touchstart', this.handleTouch.bind(this));
    canvas.addEventListener('touchmove', this.handleTouch.bind(this));
    canvas.addEventListener('touchend', this.stopDrawing.bind(this));
  }

  private startDrawing(e: MouseEvent) {
    this.isDrawing = true;
    const rect = this.signatureCanvas.nativeElement.getBoundingClientRect();
    this.lastX = e.clientX - rect.left;
    this.lastY = e.clientY - rect.top;
  }

  private draw(e: MouseEvent) {
    if (!this.isDrawing) return;
    
    const rect = this.signatureCanvas.nativeElement.getBoundingClientRect();
    const currentX = e.clientX - rect.left;
    const currentY = e.clientY - rect.top;
    
    this.ctx.beginPath();
    this.ctx.moveTo(this.lastX, this.lastY);
    this.ctx.lineTo(currentX, currentY);
    this.ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
  }

  private stopDrawing() {
    if (this.isDrawing) {
      this.isDrawing = false;
      this.drawComplete();
    }
  }

  private handleTouch(e: TouchEvent) {
    e.preventDefault();
    const touch = e.touches[0];
    const mouseEvent = new MouseEvent(e.type === 'touchstart' ? 'mousedown' : 
                                     e.type === 'touchmove' ? 'mousemove' : 'mouseup', {
      clientX: touch.clientX,
      clientY: touch.clientY
    });
    
    if (e.type === 'touchstart') {
      this.startDrawing(mouseEvent);
    } else if (e.type === 'touchmove') {
      this.draw(mouseEvent);
    }
  }
   
  ionViewDidLoad() {
    //this.selectsql();
    console.log("ionViewDidLoad")
   
    let url = "api/Leg/ImageLocation";
    this.http.get(url).subscribe(
      (data: any) => {
        this.signimgpath = data.imagePath;
      }
      ,
      err => {
        // console.log(err);
      })
  }

  drawComplete() {
    // will be notified when drawing ends
    if (this.signatureCanvas) {
      this.signimg = this.signatureCanvas.nativeElement.toDataURL();
      this.drawStart();
    }
  }

  drawStart() {
    // will be notified when drawing starts
    this.drawstart = true;
  }

  cancel() {
    this.router.navigate(['dashboard']);
  }
  async submit() {
    console.log("membersign",this.global.signmember)
    console.log("pagestay",this.global.pagestay)
    console.log("pagestayf",this.global.pagestayF)
    console.log("pagestayd",this.global.pagestayd)
        if (this.global.offline) {
          if (!this.signimg || this.isCanvasEmpty()) {
            const toast = this.toastCtrl.create({
              message: 'You must input your Signature!',
              duration: 5000,
              position: 'top',
              buttons: [
                {
                  text: 'x',
                  handler: async () => {
                   
                  }
                }
              ]
            });
            (await toast).present();
          }
          else{
        if (this.global.signmember == "F") {
          // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureFacilityImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
          // .then(() =>
          //   this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
          // )
          // .catch(e => console.log(e));
        }
        else{
          // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
          // .then(() =>
          //   this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
          // )
          // .catch(e => console.log(e));
        }
          }
        }
        else{
        if (this.global.signmember == "F") {
          let loading = this.loadingCtrl.create({
            message: "Please wait..."
          });
          let loadingPresented = false;
          let loadingTimer = setTimeout(async () => {
            (await loading).present();
            loadingPresented = true;
          }, 750);
          if(this.global.IsFacilityRefusesToSign == true){
            this.IsFacilityRefusesToSign = true
            this.FaciltyRefuseSignReason = this.global.facilityreason
          }
          else{
            this.IsFacilityRefusesToSign = false
            this.FaciltyRefuseSignReason = ""
          }
          if(this.global.facilitysign ==true){
            this.IsFacilitySigned = false
          }
          else{
            this.IsFacilitySigned = true
            this.global.facilitysignedcheck = true;
          }
          this.signn = {
            tblID: this.details == null ? this.global.tblid : this.details.tblID,
            signatureImage: this.signimg == null ? "" : this.signimg,
            signatureFacilityImagePath: this.signimgpath,
            signatureType: this.global.signmember,
            isFacilitySigned : this.IsFacilitySigned,
            IsFacilityRefusesToSign :this.IsFacilityRefusesToSign,
            FaciltyRefuseSignReason : this.FaciltyRefuseSignReason
          }
          console.log("sign",this.signn)
          this.signn = JSON.stringify(this.signn)
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
            })
          };
          let url = "api/Leg/SaveImageF";
          this.http.post(url, this.signn, httpOptions).subscribe(
            async (data: any) => {
              let navigationExtras: NavigationExtras = {
                state: {
                  sign:this.signimg,
                  record: this.details == null ? this.global.transid : this.details
                }
              };
    
              if(this.global.pagestayF == true && this.signimg == undefined){
                this.gettripnosign();
               }
               else if(this.global.pagestayF == true && this.signimg != undefined){
                this.router.navigate(['refresh'], navigationExtras);
                  this.gettripnosign();
                  this.clearPad();
               }
              // if(this.signimg != undefined && this.global.clientage >=18){
    
              //   this.router.navigate(['refresh'], navigationExtras);
              //   this.gettripnosign();
              //   this.signaturePad.clear();
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg !=1 &&  this.global.signmember == 'F' && this.global.tophysiciancheck  == 'HOME'){
              //     this.router.navigate(['refresh'], navigationExtras);
              //     this.gettripnosign();
              //     this.signaturePad.clear();
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1 && this.details.legStatus == 'PU'){
              //     this.router.navigate(['enrouteclickpage'], navigationExtras);
              //     this.signaturePad.clear();
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1){
              //     this.router.navigate(['refresh'], navigationExtras);
              //     this.gettripnosign();
              //     this.signaturePad.clear();
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg !=1){
              //     this.router.navigate(['refresh'], navigationExtras);
              //     this.gettripnosign();
              //     this.signaturePad.clear();
              //   }
                
              //   else if(this.signimg == undefined && this.global.clientage <=17 && this.global.leg == 1 ){
              //    // this.router.navigate(['refresh'], navigationExtras);
              //     this.gettripnosign();
              //   }
              //   else{ 
                  
              // //  this.router.navigate(['refresh'], navigationExtras);
              //   this.gettripnosign();
                
              // }
              if (loadingPresented) {
                (await loading).dismiss();
              } else {
                clearTimeout(loadingTimer);
              }
            }
            ,
            async err => {
              // console.log(err);
              if (!this.signimg || this.isCanvasEmpty()) {
                const toast = this.toastCtrl.create({
                  message: 'You must input your Signature!',
                  duration: 5000,
                  position: 'top',
                  buttons: [
                    {
                      text: 'x',
                      handler: async () => {
                       
                      }
                    }
                  ]
                });
                (await toast).present();
              }
              if (this.global.offline) {
                // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureFacilityImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
                //   .then(() =>
                //     this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
                //   )
                //   .catch(e => console.log(e));
              }
              if (loadingPresented) {
                (await loading).dismiss();
              } else {
                clearTimeout(loadingTimer);
              }
            }
          );
        }
        else if (this.global.signmember == "M"){
          let loading = this.loadingCtrl.create({
            message: "Please wait..."
          });
          let loadingPresented = false;
          let loadingTimer = setTimeout(async () => {
            (await loading).present();
            loadingPresented = true;
          }, 750);
          console.log("this.global.IsMemberRefusesToSign",this.global.IsMemberRefusesToSign)
          if(this.global.IsMemberRefusesToSign == true){
            this.IsMemberRefusesToSign = true
            this.MemberRefuseSignReason = this.global.memberreason
          }
          else{
            this.IsMemberRefusesToSign = false
            this.MemberRefuseSignReason = ""
          }
          console.log("this.global.mem",this.global.membersign)
          if(this.global.membersign ==true){
            this.IsMemberSigned = false
          }
          else{
            this.IsMemberSigned = true
            this.global.membersignedcheck = true;
          }
          console.log("this.IsMemberSigned",this.IsMemberSigned)
          this.signn = {
          
            tblID: this.details == null ? this.global.tblid : this.details.tblID,
            signatureImage: this.signimg == null ? "" : this.signimg,
            signatureImagePath: this.signimgpath == null ? "" :this.signimgpath,
            signatureType: this.global.signmember,
            isMemberSigned : this.IsMemberSigned,
            isMemberUnableToSign : this.global.Munabletosign == true ? true :false,
            isMemberRefusesToSign : this.IsMemberRefusesToSign,
            MemberRefuseSignReason : this.MemberRefuseSignReason
          }
          console.log("signn",this.signn)
          this.signn = JSON.stringify(this.signn)
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
            })
          };
          console.log("sign",this.signn)
          let url = "api/Leg/SaveImage";
          this.http.post(url, this.signn, httpOptions).subscribe(
            async (data: any) => {
              let navigationExtras: NavigationExtras = {
                state: {
                  sign:this.signimg,
                  record: this.details == null ? this.global.transid : this.details
                }
              };
              console.log("clientage",this.global.clientage)
              // this.router.navigate(['obtainclientsign'], navigationExtras);
              console.log("navigationExtras",navigationExtras)
              console.log("this.global.pagestayd",this.global.pagestayd)
              console.log("this.signimg",this.signimg)
              
              if(this.global.pagestayd == true && this.signimg == undefined){
                this.router.navigate(['enrouteclickpage'], navigationExtras);
                this.gettripnosign();
              }
              else if(this.global.pagestayd == true && this.signimg !=undefined){
               this.router.navigate(['enrouteclickpage'], navigationExtras);
               this.gettripnosign();
               this.clearPad();
              }
              else if(this.global.pagestay ==true && this.signimg != undefined){
                this.router.navigate(['refresh'], navigationExtras);
              this.gettripnosign();
              this.clearPad();
              }
              else{ 
                 this.gettripnosign();
               }
            //   if(this.signimg != undefined && this.global.clientage >=18){
    
            //   this.router.navigate(['refresh'], navigationExtras);
            //   this.gettripnosign();
            //   this.signaturePad.clear();
            //   }
            //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.signmember == 'M' && this.global.tophysiciancheck  == 'HOME'){
            //     this.router.navigate(['refresh'], navigationExtras);
            //     this.gettripnosign();
            //     this.signaturePad.clear();
            //   }
            //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg !=1){
            //     this.router.navigate(['refresh'], navigationExtras);
            //     this.gettripnosign();
            //     this.signaturePad.clear();
            //   }
            //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1 && this.details.legStatus == 'PU'){
            //     this.router.navigate(['enrouteclickpage'], navigationExtras);
            //   }
            //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg == 1 ){
            //     this.router.navigate(['refresh'], navigationExtras);
            //     this.gettripnosign();
            //     this.signaturePad.clear();
            //   }
              
            //   else if(this.signimg == undefined && this.global.clientage <=17 && this.global.leg == 1 && this.global.legstatus =='PU'){
            //     this.router.navigate(['enrouteclickpage'], navigationExtras);
            //     this.gettripnosign();
            //   }
            //   else if(this.signimg == undefined && this.global.clientage <=17 && this.global.leg == 1 ){
            //    // this.router.navigate(['refresh'], navigationExtras);
            //     this.gettripnosign();
            //   }
            //   else{ 
                
            //  // this.router.navigate(['refresh'], navigationExtras);
            //   this.gettripnosign();
            // //  this.router.navigate(['refresh']);
            // }
              if (loadingPresented) {
                (await loading).dismiss();
              } else {
                clearTimeout(loadingTimer);
              }
            }
            ,
            async err => {
              // console.log(err);
              if (!this.signimg || this.isCanvasEmpty()) {
                const toast = this.toastCtrl.create({
                  message: 'You must input your Signature!',
                  duration: 5000,
                  position: 'top',
                  buttons: [
                    {
                      text: 'x',
                      handler: async () => {
                       
                      }
                    }
                  ]
                });
                (await toast).present();
              }
              else{
                if (this.global.offline) {
                  // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
                  //   .then(() =>
                  //     this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
                  //   )
                  //   .catch(e => console.log(e));
                }
              }
              if (loadingPresented) {
                (await loading).dismiss();
              } else {
                clearTimeout(loadingTimer);
              }
            }
          );
        }
        
        else if (this.global.signmember == "MF"){
          console.log("this.global.MFcheck ",this.global.MFcheck )
          if(this.global.MFcheck == "M"){
          console.log("this.global.IsMemberRefusesToSign",this.global.IsMemberRefusesToSign)
          console.log("this.global.Munabletosign",this.global.Munabletosign)
          console.log("this.global.membersign",this.global.membersign)
          let loading = this.loadingCtrl.create({
            message: "Please wait..."
          });
          let loadingPresented = false;
          let loadingTimer = setTimeout(async () => {
            (await loading).present();
            loadingPresented = true;
          }, 750);
          console.log("this.global.IsMemberRefusesToSign",this.global.IsMemberRefusesToSign)
          if(this.global.IsMemberRefusesToSign == true){
            this.IsMemberRefusesToSign = true
            this.MemberRefuseSignReason = this.global.memberreason
          }
          else{
            this.IsMemberRefusesToSign = false
            this.MemberRefuseSignReason = ""
          }
          if(this.global.membersign ==true){
            this.IsMemberSigned = false
          }
          else{
            this.IsMemberSigned = true
            this.global.membersignedcheck = true;
    
          }
          this.signn = {
          
            tblID: this.details == null ? this.global.tblid : this.details.tblID,
            signatureImage: this.signimg == null ? "" : this.signimg,
            signatureImagePath: this.signimgpath == null ? "" :this.signimgpath,
            signatureType: this.global.signmember,
            isMemberSigned : this.IsMemberSigned,
            isMemberUnableToSign : this.global.MFunabletosign == true ? true :false,
            isMemberRefusesToSign : this.IsMemberRefusesToSign,
            MemberRefuseSignReason : this.MemberRefuseSignReason
          }
          console.log("signn",this.signn)
          this.signn = JSON.stringify(this.signn)
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
            })
          };
          console.log("sign",this.signn)
          let url = "api/Leg/SaveImage";
          this.http.post(url, this.signn, httpOptions).subscribe(
            async (data: any) => {
              let navigationExtras: NavigationExtras = {
                state: {
                  sign:this.signimg,
                  record: this.details == null ? this.global.transid : this.details
                }
              };
    
              if(this.global.pagestayd == true && this.signimg == undefined){
                this.router.navigate(['enrouteclickpage'], navigationExtras);
                this.gettripnosign();
              }
              else if(this.global.pagestayd == true && this.signimg !=undefined){
               this.router.navigate(['enrouteclickpage'], navigationExtras);
               this.gettripnosign();
               this.clearPad();
              }
              else if(this.global.pagestay ==true && this.signimg != undefined){
                this.router.navigate(['refresh'], navigationExtras);
              this.gettripnosign();
              this.clearPad();
              }
              else{ 
                 this.gettripnosign();
               }
    
              // this.router.navigate(['obtainclientsign'], navigationExtras);
              // if(this.signimg != undefined && this.global.clientage >=18){
    
              //   this.router.navigate(['refresh'], navigationExtras);
              //   console.log("memsign")
              // this.gettripnosign();
              // this.signaturePad.clear();
    
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 &&  this.global.signmember == 'M' && this.global.tophysiciancheck  == 'HOME'){
              //     this.router.navigate(['refresh'], navigationExtras);
              //   console.log("memsign1")
    
              // this.gettripnosign();
              // this.signaturePad.clear();
    
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg !=1){
              //     this.router.navigate(['refresh'], navigationExtras);
              //   this.gettripnosign();
              //   this.signaturePad.clear();
    
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1 && this.details.legStatus == 'PU'){
              //     this.router.navigate(['enrouteclickpage'], navigationExtras);
              //   this.gettripnosign();
              //   this.signaturePad.clear();
    
              //   }
              //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg == 1 ){
              //     this.router.navigate(['refresh'], navigationExtras);
              //     this.gettripnosign();
              //     this.signaturePad.clear();
              //   }
              //   else if(this.signimg == undefined && this.global.clientage <=17 && this.global.leg == 1 && this.global.legstatus =='PU'){
              //     this.router.navigate(['enrouteclickpage'], navigationExtras);
              //     this.gettripnosign();
              //   }
              //   else if(this.signimg == undefined && this.global.clientage <=17 && this.global.leg == 1 ){
              //    // this.router.navigate(['refresh'], navigationExtras);
              //     this.gettripnosign();
              //   }
              //   else{ 
                  
              // //  this.router.navigate(['refresh'], navigationExtras);
              //   this.gettripnosign();
              //   console.log("memsign3")
    
              //  // console.log("navigation",navigationExtras)
              // // this.gettripnosign();
              // //  this.router.navigate(['refresh']);
              // }
              if (loadingPresented) {
                (await loading).dismiss();
              } else {
                clearTimeout(loadingTimer);
              }
            }
            ,
            async err => {
              // console.log(err);
              if (!this.signimg || this.isCanvasEmpty()) {
                const toast = this.toastCtrl.create({
                  message: 'You must input your Signature!',
                  duration: 5000,
                  position: 'top',
                  buttons: [
                    {
                      text: 'x',
                      handler: async () => {
                       
                      }
                    }
                  ]
                });
                (await toast).present();
              }
              else{
                if (this.global.offline) {
                  // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
                  //   .then(() =>
                  //     this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
                  //   )
                  //   .catch(e => console.log(e));
                }
              }
              if (loadingPresented) {
                (await loading).dismiss();
              } else {
                clearTimeout(loadingTimer);
              }
            }
          );
        }
      else if(this.global.MFcheck == "F"){
        let loading = this.loadingCtrl.create({
          message: "Please wait..."
        });
        let loadingPresented = false;
        let loadingTimer = setTimeout(async () => {
          (await loading).present();
          loadingPresented = true;
        }, 750);
        if(this.global.IsFacilityRefusesToSign == true){
          this.IsFacilityRefusesToSign = true
          this.FaciltyRefuseSignReason = this.global.facilityreason
        }
        else{
          this.IsFacilityRefusesToSign = false
          this.FaciltyRefuseSignReason = ""
        }
        if(this.global.facilitysign ==true){
          this.IsFacilitySigned = false
          this.global.facilitysignedcheck = false
        }
        else{
          this.IsFacilitySigned = true
    this.global.facilitysignedcheck = true
        }
        this.signn = {
          tblID: this.global.tblid,//this.details == null ? this.global.tblid : this.details.tblID,
          signatureImage: this.signimg == null ? "" : this.signimg,
          signatureFacilityImagePath: this.signimgpath,
          signatureType: this.global.signmember,
          isFacilitySigned : this.IsFacilitySigned,
          IsFacilityRefusesToSign :this.IsFacilityRefusesToSign,
          FaciltyRefuseSignReason : this.FaciltyRefuseSignReason
        }
        console.log("sign",this.signn)
        this.signn = JSON.stringify(this.signn)
        const httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          })
        };
        let url = "api/Leg/SaveImageF";
        this.http.post(url, this.signn, httpOptions).subscribe(
          async (data: any) => {
            let navigationExtras: NavigationExtras = {
              state: {
                sign:this.signimg,
                record: this.details == null ? this.global.transid : this.details
              }
            };
           if(this.global.pagestayF == true && this.signimg == undefined){
            this.gettripnosign();
           }
           else if(this.global.pagestayF == true && this.signimg != undefined){
            this.router.navigate(['refresh'], navigationExtras);
              this.gettripnosign();
              this.clearPad();
           }
    
    //         if(this.signimg != undefined && this.global.clientage >=18){
    // console.log("1st called")
    // console.log("navigationExtras",navigationExtras)
    //           this.router.navigate(['refresh'], navigationExtras);
    //           this.gettripnosign();
    //           this.clearPad();
    //           }
    //           else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.signmember == 'MF' && this.global.tophysiciancheck  == 'HOME'){
    //             this.router.navigate(['refresh'], navigationExtras);
    //             console.log("memsign4")
    
    //           this.gettripnosign();
    //           this.signaturePad.clear();
    
    //           }
    //           else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.MFcheck == 'F'&& this.global.leg !=1 && this.global.tophysiciancheck !='HOME'){
    //             this.router.navigate(['refresh'], navigationExtras);
    //             console.log("memsign5")
    
    //           this.gettripnosign();
    //           this.signaturePad.clear();
    
    //           }
    //           else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1 && this.details.legStatus == 'PU'){
    //             this.router.navigate(['enrouteclickpage'], navigationExtras);
    //             this.gettripnosign();
    //             this.signaturePad.clear();
    //           }
    //           else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg == 1 ){
    //             this.router.navigate(['refresh'], navigationExtras);
    //             this.gettripnosign();
    //             this.signaturePad.clear();
    //           }
    //           else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg !=1){
    //             this.router.navigate(['refresh'], navigationExtras);
    //             this.gettripnosign();
    //             this.signaturePad.clear();
    //           }
             
    //           else if(this.signimg == undefined && this.global.clientage <=17 && this.global.leg == 1 ){
    //            // this.router.navigate(['refresh'], navigationExtras);
    //             this.gettripnosign();
    //           }
    //           else{ 
                
    //          // this.router.navigate(['refresh'], navigationExtras);
    //           console.log("memsign6")
    
    //           this.gettripnosign();
    //         //  this.router.navigate(['refresh']);
    //         }
            if (loadingPresented) {
              (await loading).dismiss();
            } else {
              clearTimeout(loadingTimer);
            }
          }
          ,
          async err => {
            // console.log(err);
            if (!this.signimg || this.isCanvasEmpty()) {
              const toast = this.toastCtrl.create({
                message: 'You must input your Signature!',
                duration: 5000,
                position: 'top',
                buttons: [
                  {
                    text: 'x',
                    handler: async () => {
                     
                    }
                  }
                ]
              });
              (await toast).present();
            }
            if (this.global.offline) {
              // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureFacilityImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
              //   .then(() =>
              //     this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
              //   )
              //   .catch(e => console.log(e));
            }
            if (loadingPresented) {
              (await loading).dismiss();
            } else {
              clearTimeout(loadingTimer);
            }
          }
        );
      }
      }
      else {
        let loading = this.loadingCtrl.create({
          message: "Please wait..."
        });
        let loadingPresented = false;
        let loadingTimer = setTimeout(async () => {
          (await loading).present();
          loadingPresented = true;
        }, 750);
        console.log("this.global.IsMemberRefusesToSign",this.global.IsMemberRefusesToSign)
        if(this.global.IsMemberRefusesToSign == true){
          this.IsMemberRefusesToSign = true
          this.MemberRefuseSignReason = this.global.memberreason
        }
        else{
          this.IsMemberRefusesToSign = false
          this.MemberRefuseSignReason = ""
        }
        console.log("this.global.mem",this.global.membersign)
        if(this.global.membersign ==true){
          this.IsMemberSigned = false
        }
        else{
          this.IsMemberSigned = true
          this.global.membersignedcheck = true;
        }
        this.signn = {
        
          tblID: this.details == null ? this.global.tblid : this.details.tblID,
          signatureImage: this.signimg == null ? "" : this.signimg,
          signatureImagePath: this.signimgpath == null ? "" :this.signimgpath,
          signatureType: this.global.signmember,
          isMemberSigned : this.IsMemberSigned,
          isMemberUnableToSign : this.global.Munabletosign == true ? true :false,
          isMemberRefusesToSign : this.IsMemberRefusesToSign,
          MemberRefuseSignReason : this.MemberRefuseSignReason
        }
        console.log("signn",this.signn)
        this.signn = JSON.stringify(this.signn)
        const httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          })
        };
        console.log("sign",this.signn)
        let url = "api/Leg/SaveImage";
        this.http.post(url, this.signn, httpOptions).subscribe(
          async (data: any) => {
            let navigationExtras: NavigationExtras = {
              state: {
                sign:this.signimg,
                record: this.details == null ? this.global.transid : this.details
              }
            };
            console.log("clientage",this.global.clientage)
    
            
            if(this.global.pagestayd == true ){
              this.router.navigate(['enrouteclickpage'], navigationExtras);
              this.gettripnosign();
              this.clearPad();
            }
            if(this.global.pagestay == true ){
              this.router.navigate(['refresh'], navigationExtras);
              this.gettripnosign();
              this.clearPad();
            }
            // this.router.navigate(['obtainclientsign'], navigationExtras);
          //   if(this.signimg != undefined && this.global.clientage >17){
          //     this.router.navigate(['refresh'], navigationExtras);
          //     this.gettripnosign();
          //     this.signaturePad.clear();
            
          //   }
          //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1 && this.details.legStatus == 'PU'){
          //     this.router.navigate(['enrouteclickpage'], navigationExtras);
          //     this.gettripnosign();
          //     this.signaturePad.clear();
          //   }
          //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.global.leg ==1 ){
          //     this.router.navigate(['refresh'], navigationExtras);
          //     this.gettripnosign();
          //     this.signaturePad.clear();
          //   }
          //   else if(this.signimg != undefined && this.global.clientage <= 17 && this.details.legStatus!='ER' && this.details.departTime!=null && this.details.endTime==null && (this.details.legStatus!='CO' && (this.details.legStatus=='VER_GPS' || this.details.endTime==null))){
          //     this.router.navigate(['enrouteclickpage'], navigationExtras);
          //     this.gettripnosign();
          //     this.signaturePad.clear();
          //   }else if(this.signimg != undefined && this.global.clientage <= 17 ){
          //     this.router.navigate(['refresh'], navigationExtras);
          //     this.gettripnosign()
          //     this.signaturePad.clear();
          //   }
          //   else{ 
          // //  this.router.navigate(['refresh']);
          // }
            if (loadingPresented) {
              (await loading).dismiss();
            } else {
              clearTimeout(loadingTimer);
            }
          }
          ,
          async err => {
            // console.log(err);
            if (!this.signimg || this.isCanvasEmpty()) {
              const toast = this.toastCtrl.create({
                message: 'You must input your Signature!',
                duration: 5000,
                position: 'top',
                buttons: [
                  {
                    text: 'x',
                    handler: async () => {
                     
                    }
                  }
                ]
              });
              (await toast).present();
            }
            else{
              if (this.global.offline) {
                // this.database.executeSql('UPDATE trans SET signatureImage=?,signatureImagePath=?,signatureType=? WHERE(tblID=?)', [this.signimg, this.signaturedetails, this.global.signmember, this.details.tblID])
                //   .then(() =>
                //     this.navCtrl.push(ObtainclientsignPage, { "sign": this.signimg, "record": this.details })
                //   )
                //   .catch(e => console.log(e));
              }
            }
            if (loadingPresented) {
              (await loading).dismiss();
            } else {
              clearTimeout(loadingTimer);
            }
          }
        );
      }
      }
    }

    private isCanvasEmpty(): boolean {
      const canvas = this.signatureCanvas.nativeElement;
      const blank = document.createElement('canvas');
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() === blank.toDataURL();
    }

    clearPad() {
      if (this.signatureCanvas && this.ctx) {
        const canvas = this.signatureCanvas.nativeElement;
        this.ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.signimg = null;
      } else {
        console.error('Canvas not available in clearPad');
      }
    }

    getDeviceWidth(){
      if (window.innerWidth < 650) {
        this.width = window.innerWidth - 33;
        this.deviceWidth = (window.innerWidth - 30) + 'px';
        this.canvasResize();
      }
      else {
        this.width = 600;
        this.deviceWidth = 603 + 'px';
        this.canvasResize();
      }
    }

    canvasResize() {
      if (this.signatureCanvas) {
        const canvas = this.signatureCanvas.nativeElement;
        
        canvas.width = this.width;
        canvas.height = 200;
        
        // Restore drawing styles
        this.ctx.strokeStyle = '#000000';
        this.ctx.lineWidth = 2;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
        
        // Restore the signature if it exists
        if (this.signimg) {
          const img = new Image();
          img.onload = () => {
            this.ctx.drawImage(img, 0, 0);
          };
          img.src = this.signimg;
        }
      }
    }

    memsignreason:any;
    memsignbool:any;
    facilityrefusesign :boolean=true;
    facsignreason:any;
    facsignbool:any;
    isMemsignature: any = false;
    isFacsignature: any = false;
    memberrefusesign:any;
    memberunabletosign:any;
    gettripnosign(){
      console.log("gettripsign called")
    console.log("this.global.tblid",this.global.tblid)
      let url = "api/MyScheduleTripSign/gettripnoSignReq?";
        let myParams = new URLSearchParams();
        myParams.append("tblID", this.global.tblid);// this.details == null ? this.global.tblid : this.details.tblID);
        this.http.get(url + myParams).subscribe(
          async (data: any) => {
            this.global.signmember= data.myScheduleTripSignedMemberFacilityYN.memberFacilitySignYN == false ?  data.signmember.signmember == 'N' ? 'M' : data.signmember.signmember: 'MF'; 
            this.global.myScheduleTripSignedMemberFacilityYN = data.myScheduleTripSignedMemberFacilityYN.memberFacilitySignYN;
            this.global.isMemsignature= data.getmyScheduleTripSign.isMemberSigned;
            this.global.isFacsignature= data.getmyScheduleTripSign.isFacilitySigned;
            this.global.memberunabletosign = data.getmyScheduleTripSign.isMemberUnableToSign;
            this.global.IsMemberRefusesToSign = data.getmyScheduleTripSign.isMemberRefusesToSign;
            this.global.memsignreason = data.getmyScheduleTripSign.memberRefuseReason;
            this.global.facsignreason = data.getmyScheduleTripSign.faciltyRefuseSignReason;
            this.global.IsFacilityRefusesToSign = data.getmyScheduleTripSign.isFacilityRefusesToSign;
            if(this.global.IsFacilityRefusesToSign == true){
              this.global.facsignbool = true
              this.facilityrefusesign = true
            }
            if(this.global.IsMemberRefusesToSign == true){
             // this.memsignbool = true
             this.global.memsignbool="memberrefusesign";
              this.memberrefusesign = true
             // this.global.memsignbool = this.memsignbool;
            }if(this.global.memberunabletosign == true){
              //this.memsignbool = true
             // this.unablesign = true
             this.global.memsignbool="unablesign";
            // this.global.memsignbool = this.memsignbool;
            }
            if( this.global.IsFacilityRefusesToSign == true)
            {
              console.log("facilty 1");
              this.global.facsignbool="facilityrefusesign";
             // this.global.facsignbool = this.facsignbool;
            }
            if( this.global.IsFacilityRefusesToSign == false)
            {
              console.log("facilty 2");
              this.global.facsignbool="";
            }
          }
          ,
          async err => {
         //   (await loading).dismiss();
          }
        );
      } 
}